import React from 'react';
import { useThemeMode } from '../theme/ThemeModeProvider';
import logoLight from '../assets/images/elevate-logo.png';
import logoDark from '../assets/images/elevate-logo-dark.png';

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** Always use the white-wordmark artwork, e.g. when placed over a photo. */
  onDark?: boolean;
}

/** era92 elevate logo; swaps to the white-wordmark artwork in dark mode. */
const BrandLogo: React.FC<IProps> = ({ onDark = false, ...props }) => {
  const { mode } = useThemeMode();
  return (
    <img
      alt="era92 elevate"
      {...props}
      src={onDark || mode === 'dark' ? logoDark : logoLight}
    />
  );
};

export default BrandLogo;
